var _style, _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBrows5(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Lager_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 133.1 13",
    style: {
      enableBackground: "new 0 0 133.1 13"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:url(#SVGID_1_);}\n\t.st1{opacity:0.6;fill:#D177B8;}\n\t.st2{fill:url(#SVGID_00000180335279939975585010000002183948446324913046_);}\n")), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 80.5489,
    y1: -23.5465,
    x2: 134.7094,
    y2: -23.5465,
    gradientTransform: "matrix(0.999 4.450000e-02 -4.450000e-02 0.999 -2.2427 24.1175)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#B34349"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#9C2740"
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M133.1,12.3c-0.4-0.4-3-2.5-12.7-3.7c-3.5-0.4-8.2-0.4-12.9-0.2c-9.9,0.5-20.1,1.9-20.1,1.9S82,8.4,79.3,2.9 l1.1,0c0,0,2.4,3.5,5.3,5.4l-4-5.4c0,0,6.3,0.1,16.8-0.4c10.5-0.5,18.1-2.2,18.1-2.2L116.1,0c0,0,0.1,0,0.1,0 C117.4,0.4,126.1,3.3,133.1,12.3z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M133.1,12.3c-0.4-0.4-3-2.5-12.7-3.7c-3.5-0.4-8.2-0.4-12.9-0.2C122,6.5,124,6.7,124,6.7 c-2.9-4.8-7-6.4-7.8-6.6C117.4,0.4,126.1,3.3,133.1,12.3z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000119822031465730828470000002491728492496922012_",
    gradientUnits: "userSpaceOnUse",
    x1: -1166.9349,
    y1: 50.639,
    x2: -1112.7734,
    y2: 50.639,
    gradientTransform: "matrix(-0.9976 6.890000e-02 6.890000e-02 0.9976 -1113.988 33.4027)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#B34349"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#9C2740"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000119822031465730828470000002491728492496922012_)"
    },
    d: "M0,13c0.4-0.4,2.9-2.5,12.6-4 c3.5-0.5,8.1-0.6,12.9-0.5c9.9,0.2,20.1,1.4,20.1,1.4s5.4-2.1,8-7.7l-1.1,0.1c0,0-2.3,3.6-5.2,5.6l3.9-5.5c0,0-6.2,0.3-16.8,0 C23.9,2.2,16.2,0.6,16.2,0.6l0.5-0.4c0,0-0.1,0-0.1,0C15.4,0.7,6.8,3.8,0,13z"
  }), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M0,13c0.4-0.4,2.9-2.5,12.6-4c3.5-0.5,8.1-0.6,12.9-0.5C11,6.9,9,7.1,9,7.1c2.8-4.9,6.8-6.5,7.6-6.8 C15.4,0.7,6.8,3.8,0,13z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBrows5);
export default __webpack_public_path__ + "static/media/Brows5.2d0c74a3ebebc4d937a9603322fc4849.svg";
export { ForwardRef as ReactComponent };